module.exports = __webpack_public_path__ + "img/Alignments & Mode_02_comparison.acd5165b.jpg";